module.exports = __webpack_public_path__ + "static/media/quino.b7cb4007.jpg";